// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___t486","content":"styles_content__1wAyC"};